import React, { useState, useEffect } from "react";
import Context from "../../Context";
import { useToast } from "../../components/ui";
import { Header } from "../../components/modules";

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../../components/base";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { Switch } from "../../components/ui";

import { FaPlus } from "react-icons/fa";
import {
  FiHome,
  FiShoppingBag,
  FiCreditCard,
  FiSettings,
  FiGift,
  FiUsers,
  FiUserCheck,
  FiFrown,
  FiVideo,
  FiFileText,
  FiDollarSign,
  FiSmile,
  FiShoppingCart,
} from "react-icons/fi";
import { BiLogIn } from "react-icons/bi";
import { IoReceiptOutline } from "react-icons/io5";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import constant, { statuses } from "../../constants";
import { Spinner } from "reactstrap";
import { MdLockClock } from "react-icons/md";

import {
  unixToDate,
  dateToUnix,
  roundDateToDate,
  unixToDateAndTime,
  resizeImage,
} from "../../util";
import { TimePicker, Spin } from "antd";

import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const MailSetting = () => {
  const { callApi, updateConfig, configs } = Context();
  const { toast } = useToast();

  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const updateChange = async (key, value) => {
    const { status } = await callApi(
      "configs-edit",
      {
        id: "general",
        key: key,
        value: value,
      },
      { notShowLoading: true }
    );

    if (status) {
      toast({
        className: "bg-[rgb(59,176,101)]",
        title: `อัพเดตข้อมูลสำเร็จ`,
      });
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: `อัพเดตข้อมูลไม่สำเร็จ`,
      });
    }
  };
  return (
    <div className="h-fit min-w-[600px] w-full">
      <Header
        header="Settings"
        subHeader={`ตั้งค่าไปรษณีย์`}
        icon={<FiSettings className="text-blue" />}
      />
      {loading && (
        <div className="absolute w-full col-span-3 border-r border-[#E5E7E9]  z-50 h-full bg-[rgb(255,255,255,0.6)] flex items-center justify-center">
          <Spinner className="w-4 h-4" />
        </div>
      )}

      <div className="col-span-3 mt-3 rounded-lg overflow-hidden shadow-md  bg-white  min-w-48 w-full h-fit">
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">วันเริ่มจัดส่ง</p>
          <input
            className="border-1 w-fit border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:opacity-55"
            type="date"
            disabled={loading}
            onChange={async (e) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("shipping.start", e.target.value);
              setLoading(false);
              updateConfig();
            }}
            defaultValue={configs.shipping.start}
          />
        </div>
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">วันสิ้นสุดจัดส่ง</p>
          <input
            className="border-1 w-fit border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:opacity-55"
            type="date"
            disabled={loading}
            onChange={async (e) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("shipping.end", e.target.value);
              setLoading(false);
              updateConfig();
            }}
            defaultValue={configs.shipping.end}
          />
        </div>
        <div className=" p-3 flex justify-between items-center border-b border-[#E5E7E9]">
          <p className="font-semibold">วันที่จัดส่ง</p>
          <input
            className="border-1 w-fit border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:opacity-55"
            type="date"
            disabled={loading}
            onChange={async (e) => {
              if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
              setLoading(true);
              await updateChange("shipping.send", e.target.value);
              setLoading(false);
              updateConfig();
            }}
            defaultValue={configs.shipping.send}
          />
        </div>
      </div>
    </div>
  );
};
